<template lang="html">
    
    <div class="">
        
        <div v-if="enableApproval">
            
            <div v-if="beforeRequest">
                <p>{{ fillVariable(config.beforeRequestLabel) }}</p>

                <div v-if="isInternalManutenzione && activeExtraInputs.length" class="mt-3">
                  <div class="field" v-for="ei in activeExtraInputs" :key="ei.field">
                    <label class="label">{{ ei.label }}</label>
                    <div v-if="ei.type === 'picklist'">
                      <div class="select is-fullwidth" style="height:auto">
                        <select v-model="extraValues[ei.field]" :disabled="ei.readonly">
                          <option v-for="opt in ei.options" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                        </select>
                      </div>
                    </div>
                    <div v-else>
                      <input class="input" type="text" v-model="extraValues[ei.field]" :placeholder="ei.label" :readonly="ei.readonly">
                    </div>
                  </div>
                </div>
            </div>
            
            <div v-if="afterRequest && !$store.getters.isApprover">
                <p>{{ fillVariable(config.afterRequestLabel) }} {{ statoApproval }}</p>
            </div>
            
            <div v-if="afterRequest && $store.getters.isApprover">
                <div v-if="$store.getters.canApprove">
                    <p>{{ fillVariable(config.afterRequestApproverLabel) }}</p>

                    <div class="field is-horizontal mt-3">
                        <div class="field-label is-small pl-1">
                            <!-- <label class="label">Choose Status:</label> -->
                             <label class="label">Seleziona un'opzione:</label>
                        </div>
                        <div class="field-body">
                            <div class="select is-fullwidth" style="height:auto" v-bind:class="{ 'is-danger': status == ''}">
                                <select v-model="status" @change="changeStatus">
                                    <option v-for="option in config.options" :key="option.value" :value="option.value">{{ option.label }}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div v-if="isInternalManutenzione && activeExtraInputs.length" class="mt-3">
                      <div class="field" v-for="ei in activeExtraInputs" :key="ei.field">
                        <label class="label">{{ ei.label }}</label>
                        <div v-if="ei.type === 'picklist'">
                          <div class="select is-fullwidth" style="height:auto">
                            <select v-model="extraValues[ei.field]" :disabled="ei.readonly">
                              <option v-for="opt in ei.options" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                            </select>
                          </div>
                        </div>
                        <div v-else>
                          <input class="input" type="text" v-model="extraValues[ei.field]" :placeholder="ei.label" :readonly="ei.readonly">
                        </div>
                      </div>
                    </div>
                    
                </div>
                <!-- <p v-else>You have already {{ statoApproval }} this {{ config.objLabel.toLowerCase() }}.</p> -->
                 <p v-else>Hai già {{ statoApproval }} questo {{ config.objLabel.toLowerCase() }}.</p>
            </div>
            
        </div>
        <div v-else>
            <p>{{ fillVariable(config.disableApprovalLabel) }}</p>
        </div>
        <table v-if="records.length>0" class="table">
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Approval Status</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="record in records" v-bind:key="record.Id">
                    <td>
                        {{ formatDate(record.CreatedDate) }}
                    </td>
                    <td>
                        {{ record.NewValue }}
                    </td>
                </tr>
            </tbody>
        </table>
        
    </div>
    
</template>

<script>
import moment from 'moment'

export default {
    name: 'bulmaApproval',
    components: {},
    props: {},

    data: function () {
        return {
            records:[],
            status: '',
            extraValues: {}
        }
    },

    watch: {
        extraValues: {
            handler() {
                this.commitApprovalInfo();
            },
            deep: true
        },
        status() {
            this.commitApprovalInfo();
        }
    },

    computed: {
        id() {
            const status = this.$store.getters.getProcessStatus;
            const processId = (status && status.processId) ? status.processId : this.$store.state.global_state_process;
            const verbId = (status && status.verbId) ? status.verbId : (this.$store.state.global_state_verb || 'a');
            return this.$store.getters.getVerb(this.$store.getters.getProcess(processId), verbId).pageid;
        },
        config: function() {
            return this.$store.getters.getObject(this.id).data
        },
        enableApproval() {
            const r = this.$store.getters.getRecordData;
            return !!(r && r.enableApproval__c);
            //return true;
        },
        approvalRequested() {
            const r = this.$store.getters.getRecordData;
            return !!(r && r.Approval_requested__c);
        },
        beforeRequest() {
            return ( this.enableApproval && !this.approvalRequested )
        },
        afterRequest() {
            return ( this.enableApproval && this.approvalRequested )
        },
        statoApproval() {
            return this.$store.getters.getRecordData.Approval_status__c
        },
        isInternalManutenzione() {
          const myprofile = this.$store.state.myprofile;
          if (!myprofile || !myprofile.teams) return false;
          return myprofile.teams.some(team => {
            if (!(team && team.Team__r)) return false;
            const app = team.Team__r.App_abilitata__c;
            return app === 'app_manutenzione_interni' || app === 'app_manutenzione_esterni';
          });
        },
        currentTable() {
          const status = this.$store.getters.getProcessStatus;
          const processId = (status && status.processId) ? status.processId : this.$store.state.global_state_process;
          const process = this.$store.getters.getProcess(processId);
          return process && process.table ? process.table : null;
        },
        activeExtraInputs() {
          const inputs = (this.config && Array.isArray(this.config.extraInputs)) ? this.config.extraInputs : [];
          if (!this.isInternalManutenzione) return [];
          const table = this.currentTable;
          const tableMap = table ? this.$store.state.database.get(table) : null;

          return inputs.map(ei => {
            const meta = tableMap && tableMap.get(ei.field) ? tableMap.get(ei.field) : {};
            return {
              ...ei,
              type: meta.type || 'text',
              readonly: !!meta.readonly,
              options: Array.isArray(meta.options) ? meta.options : []
            };
          });
        },
    },

    mounted: function() {
        this.loadRows();
        this.$store.commit('CLEAR_APPROVAL_INFO')
        console.log('SET_APPROVAL_INFO in bulma approval: ', this.config.submit)
        if(!this.approvalRequested) this.$store.commit('SET_APPROVAL_INFO', this.config.submit)
        this.commitApprovalInfo();

        console.log('approvalRequested:', this.approvalRequested);
        console.log('config.submit:', this.config?.submit);
    },

    methods: {
        formatDate: function(v) {
            var d=new moment(v);
            return d.format('L');
        },
        fillVariable(label) {
            console.log('-> fillVariable', label)
            if(!label.includes('{{')) return label

            do {
                var start = label.indexOf('{{')
                var end = label.indexOf('}}')
                var variable = label.slice(start+2, end).trim()
                var value = this.config[variable].toLowerCase()
                if(label.includes('{{ '+variable+' }}')) label = label.replace('{{ '+variable+' }}', '{{'+variable+'}}')
                
                label = label.replace('{{'+variable+'}}', value)

            } while (label.includes('{{'))

            return label
        },
        buildApprovalPayload() {
            const baseRaw = (this.afterRequest && this.status && this.config[this.status])
                ? this.config[this.status]
                : this.config.submit;

            const base = Array.isArray(baseRaw) ? baseRaw : [baseRaw];
            const extras = this.activeExtraInputs.map(ei => ({ field: ei.field, value: this.extraValues[ei.field] || '' }));
            return [...base, ...extras];
        },
        commitApprovalInfo() {
            const payload = this.buildApprovalPayload();
            this.$store.commit('SET_APPROVAL_INFO', payload);
        },
        changeStatus() {
            // ora deleghiamo tutto alla funzione centralizzata
            this.commitApprovalInfo();
        },

        loadRows: async function() {
            console.log('--> loadRows')
            this.records=[];

            /*
                        let res;
            
            if(this.$store.getters.getRecordData.Id && this.$store.getters.getRecordData.Id.startsWith('006')) {
                // select id, OpportunityId, Field, OldValue, NewValue, CreatedDate, Opportunity.Name from OpportunityFieldHistory where Field ='Approval_status__c' and OpportunityId ='006Kd00000cHqp7IAC'
                let p=[ 'Id', 'OpportunityId', 'Field', 'OldValue', 'NewValue', 'CreatedDate', 'Opportunity.Name' ];
                let f=[ 
                { "fieldname": "Field", "operator": "EQ", "value": "Approval_status__c" },
                { "fieldname": "OpportunityId", "operator": "EQ", "value": this.$store.getters.getRecordData.Id }
                ];
                let o=[ { "fieldname": "CreatedDate", "operator": "DESC" } ]
                res = await this.$store.dispatch('search_records', { id: this.id, object: 'OpportunityFieldHistory', filters: f, properties: p, orders: o });
            }


            if(this.$store.getters.getRecordData.Id && this.$store.getters.getRecordData.Id.startsWith('a0W')) {
                let p=[ 'Id', 'ParentId', 'Field', 'OldValue', 'NewValue', 'CreatedDate', 'Parent.Name' ];
                let f=[ 
                { "fieldname": "Field", "operator": "EQ", "value": "Approval_status__c" },
                { "fieldname": "ParentId", "operator": "EQ", "value": this.$store.getters.getRecordData.Id }
                ];
                let o=[ { "fieldname": "CreatedDate", "operator": "DESC" } ]
                res = await this.$store.dispatch('search_records', { id: this.id, object: 'Claim__History', filters: f, properties: p, orders: o });
            }
            */



            if(this.config.history) {
                var f = [... this.config.history.filters]

                f.push( { "fieldname": this.config.history.parent, "operator": "EQ", "value": this.$store.getters.getRecordData.Id } )
                var res = await this.$store.dispatch('search_records', { 
                    id: this.id, 
                    object: this.config.history.object, 
                    filters: f, 
                    properties: this.config.history.fields, 
                    orders: this.config.history.order 
                });
                if (res.data) {
                    console.log(res.data);
                    res.data.records.forEach( (r) => {
                        this.records.push(r);
                    });
                }
            }
        },
    }
}
</script>
